import { TIME_WINDOW_ALL_TIME } from "src/components/features/medium/AssetsFilter/components/TimeWindow/TimeWindow.constants";
import { parseTimeWindowSelection } from "src/components/features/medium/AssetsFilter/components/TimeWindow/TimeWindow.selection";
import { TIME_WINDOW_KEY } from "src/storage/useSearchStorage.constants";

/**
 * Named calendar tokens resolve in TimeZoneSelector. last-* / all-time / ~~
 * use a shared clock (or stored bounds), so tz is not part of the cache key.
 */
const isTzDependentTimeWindow = (timeWindow: unknown): boolean => {
  const parsed = parseTimeWindowSelection(timeWindow);
  return parsed?.kind === "named" && parsed.token !== TIME_WINDOW_ALL_TIME;
};

export const appendTzToQueryKey = <T extends readonly unknown[]>(
  queryKey: T,
  body: Record<string, unknown> | undefined,
  tz: number
) =>
  isTzDependentTimeWindow(body?.[TIME_WINDOW_KEY])
    ? ([...queryKey, tz] as const)
    : queryKey;
